<ng-container *transloco="let t">
<div class="admin-card mb-3">
  <app-admin-actions-header (onExportToPdf)="onGetFileFromServer('pdf')"
                            (onExportToXls)="onGetFileFromServer('xlsx')">
    <div slot="leadingWidgets">
      <!--          @if (searchvisible) {
            <div class="me-3 mb-3 mb-md-0">
              <app-search-rounded [name]="name" [placeholder]="t('explore.search')"
                                (searchEmitter)="handleSearchInput($event)"></app-search-rounded>
            </div>
          }-->
    </div>
    <div slot="trailingWidgets">
      <div class="pe-3">
        <app-rounded-button [label]="t('race.management.competitors.register')" (onClick)="onRegisterToRace()"
                            [isDisabled]="disableRegisterToRace"><i class="bi bi-plus-circle pe-2"></i>
        </app-rounded-button>
      </div>
    </div>
  </app-admin-actions-header>
  <app-loader [isLoading]="isLoading"></app-loader>
  @if (raceRegistrations?.length ?? 0 > 0; ) {
    <div>
    <div class="table-responsive d-xl-block d-none">
      <app-sortable-table cssClass="table table-last-row-no-border" [items]="raceRegistrations">
        <thead class="table-header">
        <tr>
          <th scope="col" [sortBy]="['id']" class="id-column-width">{{ t('event.item.id') }}</th>
          <th scope="col" class="type-column-width">{{
              t('organiser.event.management.typeOfRegistration')
            }}
          </th>
          <th scope="col" [sortBy]="['raceStart']" data-type="date" class="date-column-width">{{
              t('organiser.event.management.registration.name')
            }}
          </th>
          <th scope="col" class="competitor-count-column">
            {{ t('app.common.item.name') }}
          </th>
          <th class="more-column-width"></th>
        </tr>
        </thead>
        <tbody>
          @for (raceRegistration of raceRegistrations; track raceRegistration) {
            <tr>
              <td class="center-align">
                <div class="td-min-height">{{ raceRegistration.id }}</div>
              </td>
              <td class="center-align">
                <div class="status-badge" [ngClass]="{
                'accepted': (raceRegistration|registrationType) === TypeOfRegistration.GROUP ,
                'publishing': (raceRegistration|registrationType) === TypeOfRegistration.TEAM,
                'denied': (raceRegistration|registrationType) === TypeOfRegistration.SINGLE}">
                  <span class="fw-bold">{{ raceRegistration|registrationTypeName|uppercase }}</span>
                </div>
              </td>
              <td class="center-align">
                <div class="td-min-height">{{ raceRegistration|registrationName }}</div>
              </td>
              <td class="center-align">
                <app-language-output [hrLabel]="raceRegistration.race?.name"
                                     [enLabel]="raceRegistration.race?.nameEng"
                                     [itLabel]="raceRegistration.race?.nameIta"
                                     [siLabel]="raceRegistration.race?.nameSlo"
                                     [srLabel]="raceRegistration.race?.nameSr"
                                     [bsLabel]="raceRegistration.race?.nameBs"
                                     [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages"/>
              </td>
              <td class="text-end center-align">
                <div (click)="registrationDetails(raceRegistration)">
                    <span class="delete-icon">
                      <i class="fas fa-eye"></i>
                    </span>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </app-sortable-table>
    </div>
    <!--      Mobile table-->
    @for (raceRegistration of raceRegistrations; let isLast = $last; track raceRegistration) {
      <div class="d-block d-xl-none">
        <div class="d-flex justify-content-end align-items-center mobile-table-row" [class.isLastRow]="isLast">
          <div class="flex-grow-1">
            <div class="d-flex flex-column" [class.isLastRow]="isLast">
              <div>
                {{ t('event.item.id') }}: {{ raceRegistration.id }}
              </div>
              <div>
                <strong>{{ t("organiser.event.management.typeOfRegistration") }}
                  :</strong> {{ raceRegistration|registrationTypeName|uppercase }}
              </div>
              <div>
                <strong>{{ t('organiser.event.management.registration.name') }}:</strong> {{
                  raceRegistration|registrationName
                }};
              </div>
              <div>
                {{ t('app.common.item.name') }}:
                <app-language-output [hrLabel]="raceRegistration.race?.name"
                                     [enLabel]="raceRegistration.race?.nameEng"
                                     [itLabel]="raceRegistration.race?.nameIta"
                                     [siLabel]="raceRegistration.race?.nameSlo"
                                     [srLabel]="raceRegistration.race?.nameSr"
                                     [bsLabel]="raceRegistration.race?.nameBs"
                                     [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    </div>
  } @else {
    <app-empty-state/>
  }
  @if (hasMore) {
    <div class="d-flex justify-content-center load-more-wrapper pt-2 pb-2">
      <app-rounded-button [label]="t('app.common.load.more')" (onClick)="onLoadMore()"/>
    </div>
  }
  @if (showFabButton && (raceRegistrations?.length ?? 0) > 0) {
    <div (click)="scrollToTop()" class="scroll-to-top">
      <i class="bi bi-arrow-up"></i>
    </div>
  }
</div>
</ng-container>

